const getAttachments = (action) => action.entities.attachments;

export default function attachmentReducer(state = {}, action) {
  switch (action.type) {
    case "ATTACHMENTS_FETCHED":
      return { ...state, ...getAttachments(action) };
    default:
      return state;
  }
}
